import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { getFormattedStatusDate } from './utils';

export default class StatusDate extends PureComponent {
    static propTypes = {
        utc: PropTypes.string,
        timezone: PropTypes.string,
    };

    render() {
        const { utc, timezone } = this.props;
        const formattedDate = getFormattedStatusDate({ utc, timezone });
        let statusDate = null;

        if (formattedDate) {
            statusDate = (
                <div className="eds-g-group" data-spec="status-date">
                    <div className="eds-g-cell eds-g-cell-12-12">
                        <div className="eds-g-cell eds-g-cell-10-12 eds-g-offset-2-12">
                            <p className="eds-text-bs eds-text-color--grey-600">
                                {formattedDate}
                            </p>
                        </div>
                    </div>
                </div>
            );
        }

        return statusDate;
    }
}
